"use client";
import echo from "@/projectRoot/echo";
import { useEffect, useState } from "react";
import BroadcastNotification from "./BroadcastNotification";
import BroadcastEntityDto from "@/projectRoot/api-client/interfaces/models/broadcast/BroadcastEntity.dto";

interface Props {

}
const BroadcastListener = ({}: Props) => {
    const [notification, setNotification] = useState<any>();

    useEffect(() => {
        console.log('usao');
        if (!echo) return;
  
        echo.channel('Cubes.EcommerceCore.Models.Utils.MessageSent')
            .listen('.message.sent', (e: any) => {
                console.log('Event received:', e);
            });
  
        echo.channel('Cubes.EcommerceCore.Models.Utils.Publish')
            .listen('.publish.sent', (e: any) => {
                console.log('Published: ', e);
                setNotification(e);
            })
  
        return () => {
            echo.leaveChannel('Cubes.EcommerceCore.Models.Utils.MessageSent');
            echo.leaveChannel('Cubes.EcommerceCore.Models.Utils.Publish');
        };
    }, []);

  return (
    notification &&
    <BroadcastNotification entity={notification as BroadcastEntityDto} leaveChannel={() => echo.leaveChannel('Cubes.EcommerceCore.Models.Utils.Publish')} />
  );

};

export default BroadcastListener;
